// extracted by mini-css-extract-plugin
module.exports = {"storeWrapperMobileWhite":"StoreProductView_storeWrapperMobileWhite__2dZdA"};